import {HtmlTemplates} from './html-templates';
import ChunkReplacer from './chunkreplacer';
import logger from "./logger";
import {Login} from "../../../../assets/js/login";

export let Search = (() => {

	const db = URL_API('searchGamesByName', 'games');
	const hotslotsfetcher = URL_API('getHotSlots', 'games');
	let typing = false;
	let typingTimeout = 0;
	const typingMinChars = 3;
	const typingWaitingTime = 800;
	const suggestionsLimit = 3;
	let suggestions = {};

	//
	const getTriggers = () => {
		return document.querySelectorAll('[data-toggle="search"]')
	};

	//
	const getModal = () => {
		return document.getElementById('searchFull')
	};
	const toggleModal = () => {
		const modal = getModal();
		toggleObstacles();
		modal.classList.toggle('open');
		const inputField = getInputField(modal);
		if (inputField) {
			inputField.focus();
		}
		if (modal.classList.contains('open')) loadSuggestions();
	};

	// close modal
	const modal = document.getElementById('searchFull');

	if (modal) {
		modal.addEventListener('click', ({target}) => {
			const sectionItems = modal.querySelector('.section--items');
			const searchContainer = modal.querySelector('.search--container');
			const gameLink = target.closest('.item');
			const clearInput = target.closest('#clearInput');

			if ((target === modal || sectionItems && !sectionItems.contains(target)) &&
				!(searchContainer && searchContainer.contains(target)) &&
				!gameLink &&
				!clearInput) {
				toggleModal();
				clearInput();
			}
		});
	}

	//
	const isOpen = () => {
		return getModal.classList.contains('open') ? 1 : 0;
	}

	//
	const toggleObstacles = () => {
		const mobileBar = document.getElementById('MobileBar');
		const hambMenu = document.getElementById('BtnHamMenu');
		if (mobileBar && hambMenu) {
			mobileBar.classList.toggle('hide');
			hambMenu.classList.toggle('hide');
		}
	}

	//
	const getInputField = (modal) => {
		return modal && modal.querySelector('input[name="search"]')
	};

	//
	const getClearInputBtn = () => {
		return document.getElementById('clearInput');
	}

	//
	const begin = (e) => {

		// clear old timeout on every char input
		if (typingTimeout) {
			clearTimeout(typingTimeout);
		}

		// take user input
		let input = e.target.value;
		// remove all white spaces
		let str = input.replace(/\s+/g, '');

		typing = false;

		// start the timeout and execute after user stopped typing
		typingTimeout = setTimeout(() => {
			let len = str.length;
			switch (true) {
				// check if 3 or more chars
				case (len >= typingMinChars):
					// show clear btn
					toggleClearBtn('show');
					// show loader
					toggleLoader();
					// hide suggestions
					toggleSuggestions('hide');
					// remove previous results
					removeResults();
					// get results
					const data = getData(str)
						.then((data) => {
							// display results
							showResults(data)
								.then(() => {
									// set listeners for login
									const items = document.getElementById('searchResults').querySelectorAll('.item[data-action="login"]');
									if (items.length > 0) {
										Login.requireAuthOn(items);
									}
								});
							// hide loader
							toggleLoader();
						});
					break;
				// check if empty
				case (len === 0):
					// hide clear btn
					toggleClearBtn();
					// show suggestions
					toggleSuggestions('show');
					// remove previous results
					removeResults();
					break;
				default:
					return;

			}
		}, typingWaitingTime);

	}

	//
	const loadSuggestions = () => {
		if (suggestions && Object.keys(suggestions).length === 0 && suggestions.constructor === Object) {
			getSuggestions(suggestionsLimit)
				.then((data) => {
					if (data.success) {
						suggestions = data.success;
						outputSuggestions(data.success)
					}
				})
		} else {
			outputSuggestions(suggestions);
		}
	}

	//
	const outputSuggestions = async (data) => {
		logger.log(data);
		const iterableData = data ? Object.values(data) : [];
		let tpl = await HtmlTemplates.getTemplate(HtmlTemplates.searchGamesSuggestion, true);
		if (iterableData !== undefined && iterableData.length !== 0) {
			let suggestionsCont = document.querySelector('.block_section.searchSuggestions .section--items');
			suggestionsCont.innerHTML = '';
			iterableData.forEach((g) => {
				logger.log(g);
				suggestionsCont.innerHTML += (new ChunkReplacer)
					.add('URL_PREFIX', URL_PREFIX)
					.add('SIMPLE_NAME', g.simple_name)
					.add('NAME', g.name)
					.add('CATEGORY', g.category.replace('-', ' '))
					.replace(tpl)
			})
		}
	}

	//
	const getSuggestions = async (limit) => {
		const data = await fetch(`${hotslotsfetcher}&` + new URLSearchParams({limit: limit}));
		const res = await data.json();
		return res ? res : null;
	}

	//
	const getData = async (str) => {
		const data = await fetch(`${db}&` + new URLSearchParams({s: str}));
		const res = await data.json();
		return res ? res : null;
	}

	//
	const toggleLoader = () => {
		document.getElementById('searchLoader').classList.toggle('showing');
	}

	//
	const toggleSuggestions = (visibility) => {
		const suggestions = document.querySelectorAll('.searchSuggestions');
		if (visibility === 'hide') {
			suggestions.forEach((elem) => {
				elem.classList.add('hide')
			});
		} else {
			suggestions.forEach((elem) => {
				elem.classList.remove('hide')
			});
		}
	}

	//
	const removeResults = () => {
		document.getElementById('searchResults').innerHTML = '';
	}

	//
	const showResults = async (data) => {
		const resultsHTML = await formatResultsHTML(data);
		document.getElementById('searchResults').innerHTML = await resultsHTML;
	}

	//
	const toggleClearBtn = (visibility) => {
		const clearBtn = getClearInputBtn();
		if (visibility === 'show') {
			clearBtn.classList.add('show');
		} else {
			clearBtn.classList.remove('show');
		}
	}

	//
	const clearInput = () => {
		document.getElementById('searchInput').value = '';
		toggleClearBtn('hide');
		removeResults();
		toggleSuggestions('show');

	}

	//
	const formatResultsHTML = async (data) => {
		// html output if no results
		let html = (data === undefined || data.error !== undefined) ? `<div class="noresults">${LL('no_games')}</div>` : '';
		if (html !== '') {
			// show suggestions
			toggleSuggestions('show');
			return html;
		}
		// place iterable data into a var for clarity
		const iterableData = data.success ? Object.values(data.success) : [];
		// check if data fetched
		if (iterableData !== undefined && iterableData.length !== 0) {
			html = '';
			let tpl = await HtmlTemplates.getTemplate(HtmlTemplates.searchGamesResult, true);
			// create game item
			iterableData.map((g) => {
				logger.log(g);
				html += (new ChunkReplacer)
					.add('HREF', Login.checkIfLoggedIn()
						? `href="${URL_PREFIX}game/${g.simple_name}"`
						: `href="#" data-action="login" data-goto="${URL_PREFIX}game/${g.simple_name}"`
					)
					.add('SIMPLE_NAME', g.simple_name)
					.add('NAME', g.name)
					.add('CATEGORY', g.category[0].toUpperCase() + g.category.substring(1).replace(/-/g, ' '))
					.replace(tpl)
			});

			return html;
		}
	}

	function preventSubmit() {
		let modal = getModal();
		modal && modal.querySelector('form').addEventListener('submit', (e) => {
			e.preventDefault();
			return false;
		})
	}


	return {
		preventSubmit, getTriggers, getModal, toggleModal, getInputField, begin, getClearInputBtn, clearInput
	}
})(Login);
